import { render, staticRenderFns } from "./BannerCardImage.vue?vue&type=template&id=2c1c89e4&scoped=true"
import script from "./BannerCardImage.vue?vue&type=script&lang=js"
export * from "./BannerCardImage.vue?vue&type=script&lang=js"
import style0 from "./BannerCardImage.vue?vue&type=style&index=0&id=2c1c89e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1c89e4",
  null
  
)

export default component.exports